import ProductBadge from "../../../ProductBadge";
import SellingFastBadge from "../../../SellingFastBadge";
import RestockingSoonBadge from "../../../RestockingSoonBadge";
import PromoBadge from "./PromoBadge";
import classnames from "classnames";

const badgesFactory = ({
  restockingSoonClasses,
  productClasses,
  sellingFastClasses,
  promoClasses
}) => {
  const Badges = props => (
    <>
      {restockingSoonClasses && (
        <RestockingSoonBadge
          key={"restockingSoon"}
          {...props}
          className={classnames(restockingSoonClasses)}
        />
      )}
      {productClasses && (
        <ProductBadge
          key={"product"}
          {...props}
          className={classnames(productClasses)}
        />
      )}
      {sellingFastClasses && (
        <SellingFastBadge
          key={"sellingFast"}
          {...props}
          className={classnames(sellingFastClasses)}
        />
      )}
      {promoClasses && (
        <PromoBadge
          key={"promo"}
          {...props}
          className={classnames(promoClasses)}
        />
      )}
    </>
  );

  return Badges;
};

export default badgesFactory;
